const normalizeListSearchValue = (value: any) =>
  String(value ?? '')
    .trim()
    .toLocaleLowerCase('it-IT')

export const matchesListSearch = (search: string, values: any[]) => {
  const terms = normalizeListSearchValue(search).split(/\s+/).filter(Boolean)
  if (terms.length === 0) return true

  const searchableText = values.map(normalizeListSearchValue).join(' ')
  return terms.every((term) => searchableText.includes(term))
}
